<div class="row justify-content-center mt-3 d-flex flex-lg-row-reverse">
    <div class="col-lg-6 col-12">
        <div class="row justify-content-center mt-4">
            <div class="col-8 blue_box p-4 text-center">
                <h4 class="heading">Get Your Loan, Faster.​​​</h4>
            </div>
        </div>

        <div class="row justify-content-center">
            <div class="col-11 white_box p-4">

                <div class="row justify-content-center">
                    <div class="col-11 text-center">

                        <form [formGroup]="bankForm" (ngSubmit)="initiateAA()" novalidate>
                            <div class="row justify-content-center">
                                <div class="col-11 p-4">
                                    <div class="row justify-content-center pb-2">

                                        <!-- Account Holder Name -->
                                        <div class="col-12 col-md-6">
                                            <div class="form-group">
                                                <label class="control-label">Account Holder Name<span
                                                        class="text-danger">*</span></label>
                                                <input type="text" formControlName="accountHolderName"
                                                    (keypress)="allowOnlyLetters($event)" class="form-control"
                                                    placeholder="Name as per bank records" />
                                                <div *ngIf="m.accountHolderName.touched && m.accountHolderName.invalid"
                                                    class="error">
                                                    <div *ngIf="m.accountHolderName.errors?.required">Account
                                                        holder
                                                        name is required
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Account Type -->
                                        <div class="col-12 col-md-6">
                                            <div class="form-group">
                                                <label class="control-label">Account Type<span
                                                        class="text-danger">*</span></label>
                                                <select formControlName="accountType" class="form-select">
                                                    <option value="" disabled selected>Select account type
                                                    </option>
                                                    <option value="SAVING">Saving</option>
                                                    <option value="CURRENT">Current</option>
                                                </select>
                                                <div *ngIf="m.accountType.touched && m.accountType.invalid"
                                                    class="error">
                                                    <div *ngIf="m.accountType.errors?.required">Please select
                                                        account
                                                        type</div>
                                                </div>
                                            </div>
                                        </div>



                                        <!-- Account Number -->
                                        <div class="col-12 col-md-6">
                                            <div class="form-group">
                                                <label class="control-label">Account Number<span
                                                        class="text-danger">*</span></label>
                                                <input type="text" formControlName="accountNumber" class="form-control"
                                                    placeholder="Enter account number" maxlength="18"
                                                    (keypress)="allowOnlyNumbers($event)" />
                                                <div *ngIf="m.accountNumber.touched && m.accountNumber.invalid"
                                                    class="error">
                                                    <div *ngIf="m.accountNumber.errors?.required">Account number
                                                        is
                                                        required</div>
                                                    <div *ngIf="m.accountNumber.errors?.pattern">Enter a valid
                                                        account
                                                        number</div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- IFSC Code -->
                                        <div class="col-12 col-md-6">
                                            <div class="form-group">
                                                <label class="control-label">IFSC Code<span
                                                        class="text-danger">*</span></label>
                                                <input type="text" formControlName="ifscCode"
                                                    class="form-control text-uppercase" maxlength="11"
                                                    placeholder="Enter IFSC code" />
                                                <div *ngIf="m.ifscCode.touched && m.ifscCode.invalid" class="error">
                                                    <div *ngIf="m.ifscCode.errors?.required">IFSC code is
                                                        required</div>
                                                    <div *ngIf="m.ifscCode.errors?.pattern">Enter a valid IFSC
                                                        code
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                    <div class="form-group info-list" style="text-align: left;">
                                        <ul>
                                            <li>We require your bank information to securely verify your bank details.​
                                            </li>
                                            <li>This is a secure and RBI-regulated process.</li>
                                            <li>We use the Account Aggregator framework to access your banking data only
                                                with your explicit consent.​</li>
                                            <li>This is the safest way to share financial information—approved and
                                                regulated by the RBI.</li>
                                        </ul>
                                    </div>


                                    <!-- Submit Button -->
                                    <div class="row justify-content-center text-center buttonDiv mt-4">
                                        <div class="col-12">
                                            <button class="btn btn-warning" [disabled]="!bankForm.valid" type="submit">
                                                Proceed — Securely Share Your Bank Data
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <p class="text-center mb-4 footer-text"><small>Your bank details will be used to set up your eNACH
                        mandate for auto
                        debit of EMIs.</small></p>
            </div>
        </div>
    </div>
    <div class="col-lg-5 col-11">
        <app-left-icons></app-left-icons>
    </div>
</div>

<ngx-spinner type="ball-spin-clockwise" size="medium"></ngx-spinner>